<template>
  <div class="px-2">
    <z-loading :is-full-page="false" :active="isLoading"/>
    <!--    Connect with PACI step-->
    <div :style="$i18n.locale === 'ar' ? `text-align: right;` : `text-align: left;`" class="pb-6">
      <div class="pb-4" v-if="onGoingPaci">
        <div class="flex flex-row items-center pb-2">
          <img :style="$i18n.locale === 'ar' ? `margin-left: 8px;` : `margin-right: 8px;`" class="w-12"  src="../../assets/paci_icon.png" alt='paci-icon' />
          <p class="font-bold text-xl text-eezeeGray-dark">
            {{ $t('EezeeAuthenticationSent') }}
          </p>
        </div>
          <p class="text-eezeeGray-dark"  v-html="$t('EezeeAuthenticationSentBody')"/>
        <z-button class="w-full mt-4" @click="() => {this.$router.go()}">
          {{ $t('EezeePaciRefresh') }}
        </z-button>
      </div>

      <div v-else>
        <div>
        <p class="font-bold text-2xl" :style="this.isEezeeTheme ? 'color: #4f4f4f' : 'color: #001136'">
          {{ $t('EezeeEnterId') }}
        </p>
        <p class="text-eezeeGray-light pe-24">{{ $t('EnterIdBody') }}</p>
      </div>
      <!-- the -mx-n is to ignore the parent padding for the divider line to be across the x axis -->
      <validation-observer
        ref="observer"
        tag="div"
        class="flex flex-col py-3 gap-3 items-center">
        <z-input-with-validation
          rules="eezee_civil_id|eezee_must"
          v-model="civilId"
          class="w-full"
          input-classes="rounded-lg border-gray-200 h-16 text-gray-900 placeholder-eezeeGray-light"
          :placeholder="$t('EezeeEnterIdPlaceHolder')">
        </z-input-with-validation>
        <z-input-with-validation
            rules="email|eezee_must"
            v-model="email"
            class="w-full"
            input-classes="rounded-lg border-gray-200 h-16 text-gray-900 placeholder-eezeeGray-light"
            :placeholder="$t('EnterEmailPlaceHolder')">
        </z-input-with-validation>
        <button
          @click="submit"
          class="w-full rounded-lg h-16 font-bold text-white items-center justify-center"
          :style="this.isEezeeTheme ? 'border-radius: 8px; backgroundColor: #d12b8a' : 'border-radius: 9999px; backgroundColor: #DB0A40'">
          {{ $t('EnterIdButton') }}
        </button>
      </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import ZInputWithValidation from '@/zain-component-library/src/lib-components/ZInputWithValidation.vue'
import { ValidationObserver } from 'vee-validate'
import ZLoading from "@/zain-component-library/src/lib-components/ZLoading.vue";
import ZButton from "@/zain-component-library/src/lib-components/ZButton.vue";

export default {
  name: 'EezeeVerification',
  components: {ZLoading, ZButton, ZInputWithValidation, ValidationObserver },
  data() {
    return {
      // steps are: [ 'chooseMethod', 'connectToKuwaitMobileId']
      currentStep: 'chooseMethod',
      civilId: null,
      email: null,
      isLoading: false,
      isEezeeTheme: this.$route.path.startsWith('/eezee')
    }
  },
  methods: {
    async submit() {
      let isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }

      // check if user not under 18
      const birthCentury = this.civilId?.substring(0, 1) === '3' ? '20' : '19'
      const birthYear = this.civilId?.substring(1, 3)
      const birthMonth = this.civilId?.substring(3, 5)
      const birthDay = this.civilId?.substring(5, 7)

      const dateOfBirth = new Date(parseInt(birthCentury + birthYear), parseInt(birthMonth) - 1, parseInt(birthDay))
      const currentDate = new Date()

      let age = (currentDate.getFullYear() - dateOfBirth.getFullYear())

      if (currentDate.getMonth() + 1 < dateOfBirth.getMonth() || currentDate.getMonth() + 1 === dateOfBirth.getMonth() && currentDate.getDate() < dateOfBirth.getDate()){
        age--
      }

      if(Number.isNaN(age) || age < 18) {
        this.$buefy.toast.open({
          duration: 5000,
          message: this.$t('EezeeUnder18'),
          type: 'is-warning'
        })
        return
      }

      this.isLoading = true
      await this.$store.dispatch('submitPaciPartner', {
        civilId: this.civilId,
        email: this.email
      })
      this.isLoading = false
    }
  },
  computed: {
    onGoingPaci() {
      return this.$store.state.updateIdInfoResult && this.$store.state.updateIdInfoResult !== 'error' && this.$store.state.queryRequestStatusResult?.result?.status !== 'UserDeclined'
    }
  }
}
</script>

<style scoped></style>
